/**
 * Script for the "Featured in" section.
 *
 * Displays a sequence of logos in a seamless loop. The script makes the animation
 * speed proportional across screen sizes.
 */
import dom from '../../helpers/dom';

const featuredIn = () => {
  const sectionClassname = 'js-qusd-section-featured-in';
  const itemClassname = 'js-qusd-section-featured-in-slide';
  const cssAnimationName = 'qusd-section-featured-in-animation';
  const originalItemWidth = 2392;
  const baseSpeed = 70; // Pixels/second.
  const baseDuration = originalItemWidth / baseSpeed;
  let sections = [];
  let sectionsFound = false;

  const getResponsiveDuration = (item) => (baseDuration * item.offsetWidth) / originalItemWidth;

  const addAnimationProps = (item) => {
    item.style.setProperty('animation-name', cssAnimationName);
    item.style.setProperty('animation-duration', `${getResponsiveDuration(item)}s`);
  };

  const removeAnimationProps = (item) => {
    item.style.removeProperty('animation-name');
    item.style.removeProperty('animation-duration');
    /*
     * Calling `offsetWidth` triggers reflow of the element.
     * Otherwise, the animation won't stop if started immediately after.
     */
    // eslint-disable-next-line no-void
    void item.offsetWidth;
  };

  const restartAnimation = (section) => {
    const items = dom.getByClassName(itemClassname, section);
    items.forEach((item) => {
      removeAnimationProps(item);
      addAnimationProps(item);
    });
  };

  const initAnimation = (section) => {
    const items = dom.getByClassName(itemClassname, section);
    items.forEach((item) => {
      addAnimationProps(item);
    });
  };

  const init = () => {
    sections = dom.getByClassName(sectionClassname);
    sectionsFound = sections.length > 0;
    if (sectionsFound) {
      sections.forEach((section) => {
        initAnimation(section);
      });
    }
  };

  const onResize = () => {
    if (sectionsFound) {
      sections.forEach((section) => {
        restartAnimation(section);
      });
    }
  };

  return {
    init,
    onResize,
  };
};
export default featuredIn();
